import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AmcAccess } from '../types/user';

export interface UserState {
  userId: string | null;
  name: string | null;
  email: string | null;
  role: string | null;
  jwtToken: string | null;
  amcIds?: string[];
  amcAccess?: AmcAccess[];
}

const initialState: UserState = {
  userId: null,
  name: null,
  email: null,
  role: null,
  jwtToken: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState>) => {
      state.userId = action.payload.userId;
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.role = action.payload.role;
      state.jwtToken = action.payload.jwtToken;
      state.amcIds = action.payload.amcIds;
      state.amcAccess = action.payload.amcAccess;
    },
    clearUser: (state) => {
      state.userId = null;
      state.name = null;
      state.email = null;
      state.role = null;
      state.jwtToken = null;
      state.amcIds = undefined;
      state.amcAccess = undefined;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
